import CarTopFilterContainer from "../../../components/car/other/CarTopFilter";

const CarTopFilter = () => {
  return <CarTopFilterContainer />;
};

export default CarTopFilter;
